// extracted by mini-css-extract-plugin
module.exports = {"root":"Selector_root__eprbQ","focused":"Selector_focused__17MFr","select":"Selector_select__asAOz"};